<template>
  <div class="nestable-table-cell" :style="{'flex-basis': flexBasis}">
    <div class="nestable-table-cell-contents" style="display: flex">
      <div v-if="showNesting" v-html="indentDisplay" class="nestable-table-indent" />
      <div style="flex-grow: 1">
        <slot />
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'NestableTableCell',
  props: {
    index: Number,
    showNesting: {
      type: Number,
      default: 0
    },
    columns: Array
  },
  computed: {
    indentDisplay() {
      return '&nbsp;'.repeat(this.showNesting*3) + (this.showNesting > 0 ? '<i class="fas fa-caret-right"></i>&nbsp;&nbsp;' : '')
    },
    flexBasis() {
      if(this.columns[this.$props.index] && this.columns[this.$props.index].width)
        return this.columns[this.$props.index].width
      return '100%'      
    }
  }
}
</script>